<template>
  <img
    v-if="dataUrl"
    :src="dataUrl"
    class="qr-image"
    width="77"
    height="77"
    :alt="t('content-creator.whatsapp.qr-code-alt')"
  />
</template>

<script setup lang="ts">
import { useQRCode } from '@vueuse/integrations/useQRCode'
import { toRef } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{ url: string }>()
const { t } = useI18n()
const dataUrl = useQRCode(toRef(props, 'url'), { width: 154, margin: 2 })
</script>

<style scoped>
.qr-image {
  display: block;
  image-rendering: auto;
}
</style>
